import styled from 'styled-components';

export const FooterStyle = styled.div`
color: #EDEBF2;
background-color: #FFF !important;
`;



// WEBPACK FOOTER //
// ./src/styles/Grid.js